import { Route } from '@angular/router';
import { CustomerLayout } from '../pages/customer/customer.layout';

export const customerRoutes: Route[] = [
  {
    path: 'customer',
    component: CustomerLayout,
    children: [
      {
        path: '',
        redirectTo: 'notice',
        pathMatch: 'full',
      },
      {
        path: 'faq',
        children: [
          {
            path: '',
            loadComponent: () => import('../pages/customer/faq/faq.page'),
          },
        ],
      },
      {
        path: 'notice',
        children: [
          {
            path: '',
            loadComponent: () => import('../pages/customer/notice/notice.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('../pages/customer/notice/notice-detail/notice-detail.page'),
          },
        ],
      },
      {
        path: 'inquiry',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../pages/customer/inquiry/inquiry-form/inquiry-form.page'),
          },
          {
            path: 'complete',
            loadComponent: () =>
              import('../pages/customer/inquiry/inquiry-complete/inquiry-complete.page'),
          },
        ],
      },
    ],
  },
];
